import React from 'react';

/**
 * OrderSummary Component
 * Displays order totals and pricing breakdown
 */
export const OrderSummary = ({
  itemCount,
  subtotal,
  discount,
  tax,
  total,
  discountPercent,
  onDiscountChange,
  taxPercent,
  onTaxChange,
  transactionType
}) => {
  return (
    <div className="bg-white border-t border-gray-200 p-4">
      {/* Item Count */}
      <div className="flex justify-between items-center pb-3 border-b border-gray-100">
        <span className="text-gray-700 font-medium">Items:</span>
        <span className="font-semibold text-lg text-gray-900">{itemCount}</span>
      </div>

      {/* Subtotal */}
      <div className="flex justify-between items-center py-2 text-gray-700">
        <span>Subtotal:</span>
        <span className="font-medium">₱{subtotal.toFixed(2)}</span>
      </div>

      {/* Discount Section */}
      <div className="py-2 border-b border-gray-100">
        <div className="flex justify-between items-center mb-1">
          <label htmlFor="discount" className="text-gray-700 text-sm">
            Discount:
          </label>
          <input
            id="discount"
            type="number"
            min="0"
            max="100"
            step="0.01"
            value={discountPercent}
            onChange={(e) => onDiscountChange(parseFloat(e.target.value) || 0)}
            placeholder="0"
            className="w-16 px-2 py-1 border border-gray-300 rounded text-right text-sm"
          />
          <span className="text-gray-600 ml-1">%</span>
          <span className="font-medium ml-4 text-red-600">
            -₱{discount.toFixed(2)}
          </span>
        </div>
      </div>

      {/* Tax Section */}
      {transactionType !== 'takeout' && (
        <div className="py-2 border-b border-gray-100">
          <div className="flex justify-between items-center mb-1">
            <label htmlFor="tax" className="text-gray-700 text-sm">
              Tax:
            </label>
            <input
              id="tax"
              type="number"
              min="0"
              max="100"
              step="0.01"
              value={taxPercent}
              onChange={(e) => onTaxChange(parseFloat(e.target.value) || 0)}
              placeholder="0"
              className="w-16 px-2 py-1 border border-gray-300 rounded text-right text-sm"
            />
            <span className="text-gray-600 ml-1">%</span>
            <span className="font-medium ml-4 text-blue-600">
              +₱{tax.toFixed(2)}
            </span>
          </div>
        </div>
      )}

      {/* Total */}
      <div className="flex justify-between items-center pt-3 mt-2 border-t-2 border-gray-300">
        <span className="text-lg font-bold text-gray-900">Total:</span>
        <span className="text-2xl font-bold text-green-600">
          ₱{total.toFixed(2)}
        </span>
      </div>
    </div>
  );
};

export default OrderSummary;
